











import Vue from "vue";
import { mapState } from "vuex";
import { Route } from "vue-router";

export default Vue.extend({
  data() {
    return {
      isHomePage: this.$route.name === "Home"
    };
  },

  computed: mapState(["title"]),

  watch: {
    $route(to: Route) {
      this.isHomePage = to.name === "Home";
    }
  }
});
